import { defineStore } from 'pinia'
export const useModal = defineStore('modal', {
    state: () => {
        return {
            modals: [
                {
                    name : 'productModal',
                    open : false
                }
            ],
            paylode : {
                id : null
            }
        }
    },
    actions: {
        open(name) {
            const modal = this.modals.find(m => m.name == name)
            if (modal) modal.open = true
          },
          close(name) {
            const modal = this.modals.find(m => m.name == name)
            if (modal) modal.open = false
          }
    }
})